
import React from 'react';
import { Route, Navigate } from 'react-router-dom';
import { useAuth } from '@/context/AuthContext';
import OptimizedLanding from '@/pages/OptimizedLanding';
import Login from '@/pages/auth/Login';
import Register from '@/pages/auth/Register';
import AcceptInvitation from '@/pages/staff/AcceptInvitation';
import RealtimeProbePage from '@/pages/RealtimeProbePage';

interface PublicRouteProps {
  children: React.ReactNode;
}

export const PublicRoute: React.FC<PublicRouteProps> = ({ children }) => {
  const { isAuthenticated, isLoading } = useAuth();

  // Show loading state while auth is being determined
  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-white">
        <div className="animate-spin rounded-full h-16 w-16 border-b-2 border-blue-600"></div>
      </div>
    );
  }

  // Redirect authenticated users to the main app
  if (isAuthenticated) {
    return <Navigate to="/main" replace />;
  }

  // Show public content for unauthenticated users
  return <>{children}</>;
};

export const getPublicRoutes = () => [
  <Route key="root" path="/" element={
    <PublicRoute>
      <OptimizedLanding />
    </PublicRoute>
  } />,
  <Route key="login" path="/login" element={
    <PublicRoute>
      <Login />
    </PublicRoute>
  } />,
  <Route key="register" path="/register" element={
    <PublicRoute>
      <Register />
    </PublicRoute>
  } />,
  <Route key="staff-invite" path="/staff/invite/:token" element={<AcceptInvitation />} />,
  // Temporary diagnostic route for Realtime smoke test. Remove after verification.
  <Route key="probe-realtime" path="/probe-realtime" element={<RealtimeProbePage />} />
];
